<form [formGroup]="conjugeForm" class="blue-box guarantor">
  <h2 class="conjuge__title">Informações do Cônjuge</h2>
  <div class="form-group">
    <span class="icon conjuge"></span>
    <div class="inputs">
      <label for="nomeConjuge">Nome</label>
      <input
        class="form-control"
        type="text"
        placeholder="Nome do cônjuge"
        maxlength="60"
        required
        appShowErrorMessages
        formControlName="nomeConjuge"
        name="nomeConjuge"
        uppercase
        [charOnly]="true"
        appMinTwoWords
        [removeSpaceBeginEnd]="true"
        [charOnly]="true"
      />
    </div>
  </div>

  <div class="form-group">
    <span class="icon id-number"></span>
    <div class="inputs">
      <label for=".value">CPF</label>
      <input
        class="form-control"
        type="text"
        placeholder="000.000.000-00"
        mask-number
        [mask]="'000.000.000-00'"
        inputmode="numeric"
        appCpfValidator
        formControlName="cpfConjuge"
        name="cpfConjuge"
        required
        appShowErrorMessages
        requiredMessage="O campo CPF é obrigatório"
      />
      <div class="text-danger" *ngIf="cpfCliente && cpfConjuge.value === cpfCliente">o CPF do cônjuge não pode ser o mesmo do cliente  </div>
    </div>
  </div>

  <div class="form-group">
    <span class="icon aniversario"></span>
    <div class="inputs">
      <label for="dataNascimentoConjuge">Data de Nascimento</label>
      <input
        class="form-control"
        type="text"
        mask-number
        [mask]="'00/00/0000'"
        placeholder="00/00/0000"
        formControlName="dataNascimentoConjuge"
        name="dataNascimentoConjuge"
        appDataValidator
        [dateRange]="dataRange"
        required
        appShowErrorMessages
      />
    </div>
  </div>

  <div class="form-group">
    <span class="icon mobile"></span>
    <div class="inputs">
      <label for="telefoneConjuge">Celular do cônjuge</label>
      <input
          name="telefoneConjuge"
          type="tel"
          formControlName="telefoneConjuge"
          [minLength]="11"
          [maxLength]="15"
          class="form-control"
          placeholder="(00) 00000-0000"
          appTelefone
          appCelularValidator
          required
          appOnlyDigitsLengthValidator
          appShowErrorMessages
          (focus)="clearErrorMessage()"
      />
      <div *ngIf="errorMessage" class="text-danger">
        {{ errorMessage }}
      </div>
    </div>
  </div>

  <div class="form-group">
    <span class="icon classe-profissional"></span>
    <div class="inputs">
      <label for="classeProfConjuge">Classe Profissional</label>
      <select
          class="form-control"
          appShowErrorMessages
          required
          requiredMessage="O campo Classe Profissional é obrigatório"
          name="classeProfConjuge"
          formControlName="classeProfConjuge"
          (change)="onClasseProfissionalChange()">
      <option value="" selected hidden>Selecione...</option>
      <option *ngFor="let classe of classesProfissionaisConjuge" value="{{ classe.id }}">{{ classe.descricao }}</option>
    </select>
    </div>
  </div>

  <div class="form-group">
    <span class="icon profissao"></span>
    <div class="inputs">
      <label for="cargoConjuge">Profissão</label>
      <select
          class="form-control"
          required
          appShowErrorMessages
          requiredMessage="O campo Profissão é obrigatório"
          name="cargoConjuge"
          formControlName="cargoConjuge">
        <option value="" selected hidden>Selecione...</option>
        <option *ngFor="let profissao of profissoesConjuge" value="{{ profissao.id }}">{{ profissao.descricao }}</option>
      </select>
    </div>
  </div>
</form>
